import { motion } from 'framer-motion'
import { styled, createGlobalStyle } from 'styled-components'
import { COLORS } from 'consts/colors'
import { SHADOWS } from 'styles/consts'
import { SLIDE_UP_Z_INDEX } from 'consts/zIndex'

export const Container = styled.div<{ $zIndex?: number }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  /* Dynamic viewport height instead of bottom: 0. A fixed box bottoms out on the
     LARGE viewport, so on a real mobile browser its bottom edge sits behind the
     retractable toolbar — while the panels inside size themselves in dvh
     (100dvh minus MOBILE_HEADER_HEIGHT and friends). The two units agree only
     when dvh == lvh, i.e. in a desktop simulator, which is why an over-tall
     drawer squeezed its footer out of view on device but never in devtools.
     Measuring this box in dvh too keeps every panel's math consistent. */
  height: 100dvh;
  z-index: ${({ $zIndex }) => $zIndex ?? SLIDE_UP_Z_INDEX};
`

export const Content = styled(motion.div)<{
  $bottomMargin: number
  $minHeight?: string
  $maxHeight?: string
}>`
  position: absolute;
  left: 0;
  right: 0;
  bottom: ${({ $bottomMargin }) => `${$bottomMargin}px`};
  border-radius: 16px 16px 0 0;
  box-shadow: ${SHADOWS.popup};
  background-color: ${COLORS.surface};
  padding-top: 20px;
  max-height: ${({ $maxHeight }) => $maxHeight ?? 'calc(100% - 148px)'};
  min-height: ${({ $minHeight }) => $minHeight ?? '0'};
  display: flex;
  flex-direction: column;
`

export const CloseLine = styled.div`
  margin: 0 auto;
  width: 60px;
  height: 4px;
  background-color: ${COLORS.border};
  cursor: pointer;
  border-radius: 4px;
`

export const BackdropOverlay = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.4);
`

export const GlobalScrollBlock = createGlobalStyle`
  body {
    overflow: hidden !important;
  }
`
